import { HorizontalBar, mixins } from "vue-chartjs";
const { reactiveProp } = mixins;

export default {
  name: "horizontal-bar-chart",
  extends: HorizontalBar,
  mixins: [reactiveProp],
  props: {
    chartdata: {
      type: Object,
      default: null
    },
    options: {
      type: Object,
      lineTension: 0,
      default: null,
      responsive: true
    }
  },
  mounted() {
    this.renderChart(this.chartData, this.options);
  }
};



// WEBPACK FOOTER //
// ./src/components/charts/HorizontalBarChart.js